import { createContext, useContext } from 'react';
import * as React from 'react';

import { NavigateAction, NavigationState } from './navigationProvider.types';

type Props = {
  children: React.ReactNode;
  navigate: NavigateAction;
};

export const NavigationStateContext = createContext<NavigationState>({} as NavigationState);
export const useNavigation = () => useContext(NavigationStateContext);

export const NavigationProvider: React.FC<React.PropsWithChildren<Props>> = ({
  navigate,
  children,
}) => {
  const state = { navigate };

  return (
    <NavigationStateContext.Provider value={state}>{children}</NavigationStateContext.Provider>
  );
};
